import { render, staticRenderFns } from "./historical.vue?vue&type=template&id=2094cc86&scoped=true"
import script from "./historical.vue?vue&type=script&lang=js"
export * from "./historical.vue?vue&type=script&lang=js"
import style0 from "./historical.vue?vue&type=style&index=0&id=2094cc86&prod&lang=scss"
import style1 from "../scss/index.scss?vue&type=style&index=1&id=2094cc86&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094cc86",
  null
  
)

export default component.exports